/**
 * StudentTutorConversationScreen — la route `messenger` de l'espace élève : la conversation avec
 * UN tuteur (patron A, avec une boîte d'envoi locale).
 *
 * Fil seul : le tuteur arrive par la route comme aujourd'hui (rien pour le tuteur principal,
 * `tutorId` pour un autre — `MyCoachTabScreen.js`, « Contacter mon tuteur », la notification d'un
 * message), la composition (`useStudentTutorConversation`) → `<StudentTutorConversationPage>` et
 * ses fenêtres. Remplace `common/messenger/ChatScreen.js` (branche élève), interrupteur allumé.
 */
import React from "react"

import { StudentTutorConversationPage } from "../../../../../../design-system/student"
import { useBackOr } from "../../../hooks/useBackOr"
import { type StudentSpaceScreenProps } from "../studentSpaceRouteTypes"
import { StudentTutorConversationOverlays } from "./StudentTutorConversationOverlays"
import { useStudentTutorConversation } from "./useStudentTutorConversation"

export function StudentTutorConversationScreen(props: StudentSpaceScreenProps) {
    const tutorId = (props.route?.params?.tutorId as string | number | undefined) ?? null
    // `ChatScreenHeader._goBack` : la pile, sinon l'accueil (un lien ouvert à froid).
    const onBack = useBackOr("menu")
    const { page, overlays } = useStudentTutorConversation({ tutorId, embedded: false, onBack })

    return (
        <>
            <StudentTutorConversationPage {...page} />
            <StudentTutorConversationOverlays {...overlays} />
        </>
    )
}
